// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".min-height[data-v-12dc6aa1]{min-height:40em}.patch-version[data-v-12dc6aa1]{margin-top:5px}.header-warnings .banner[data-v-12dc6aa1]{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
